import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import Nav from '../components-public/Nav'
import HeroSection from '../components-public/HeroSection'
import MarqueeSection from '../components-public/MarqueeSection'
import StatsSection from '../components-public/StatsSection'
import SectorsSection from '../components-public/SectorsSection'
import CapabilitiesSection from '../components-public/CapabilitiesSection'
import ProcessSection from '../components-public/ProcessSection'
import CasesSection from '../components-public/CasesSection'
import BlogPreviewSection from '../components-public/BlogPreviewSection'
import CTASection from '../components-public/CTASection'
import Footer from '../components-public/Footer'

export default function HomePage() {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('visible') })
    }, { threshold: 0.12 })
    document.querySelectorAll('.fade-in').forEach((el) => observer.observe(el))
    setTimeout(() => {
      document.querySelectorAll('.hero .fade-in').forEach((el) => el.classList.add('visible'))
    }, 80)
    return () => observer.disconnect()
  }, [])

  return (
    <>
      <Helmet>
        <title>Orken Tecnologia — Sistemas, Apps e Consultoria</title>
        <meta name="description" content="Orken Tecnologia: sistemas web, apps mobile e consultoria em tecnologia para o setor público e privado." />
      </Helmet>
      <Nav />
      <HeroSection />
      <MarqueeSection />
      <StatsSection />
      <SectorsSection />
      <CapabilitiesSection />
      <ProcessSection />
      <CasesSection />
      <BlogPreviewSection />
      <CTASection />
      <Footer />
    </>
  )
}
